import Resource from '@/services/resources/common';

export default class GeometryTypeResource extends Resource {
  constructor(entrypoint = '/geometry_types', alias = 'GeometryType') {
    super(entrypoint, alias);
  }
}
